import { Box, Typography } from '@mui/material';
import { useSelector } from 'react-redux';

import { FHCopyToClipboard } from '../../../base';
import { FORTA_BLUE } from '../../../../utils/colors';

import type { RootState } from '../../../../store';

interface ClaimServiceLineDetailsProps {
  showPreview?: boolean;
  fieldContainerStyle: any;
  fieldLabelStyle: any;
  fieldContentStyle: any;
}

const sectionTitleStyle = {
  fontWeight: 500,
  textAlign: 'left',
};

const dividerStyle = {
  display: 'flex',
  width: '100%',
  height: '2px',
  backgroundColor: FORTA_BLUE.light2,
};

function ClaimServiceLineDetails(props: ClaimServiceLineDetailsProps) {
  const { showPreview, fieldContainerStyle, fieldLabelStyle, fieldContentStyle } = props;

  const { current: claim, claimPreview } = useSelector((state: RootState) => state.claims);

  const claimData = showPreview ? { form_1500_data: claimPreview } : claim;

  if (!claimData?.form_1500_data) return <></>;
  const { form_1500_data } = claimData;

  return (
    <>
      <Box display={'flex'} flexDirection={'column'} data-testid="claimServiceLineDetailsContainer">
        <Typography variant="h4" sx={sectionTitleStyle} mb={3}>
          Rendering provider
        </Typography>
        <Box sx={fieldContainerStyle}>
          <Typography sx={fieldLabelStyle}>Last/ Organization name</Typography>
          <FHCopyToClipboard
            text={
              form_1500_data?.claim_and_service_line_details?.rendering_provider
                ?.last_or_organization_name || ''
            }
          />
        </Box>
        <Box sx={fieldContainerStyle}>
          <Typography sx={fieldLabelStyle}>First name</Typography>
          <FHCopyToClipboard
            text={
              form_1500_data?.claim_and_service_line_details?.rendering_provider?.first_name || ''
            }
          />
        </Box>
        {form_1500_data?.claim_and_service_line_details?.rendering_provider?.middle_name && (
          <Box sx={fieldContainerStyle}>
            <Typography sx={fieldLabelStyle}>Middle name</Typography>
            <FHCopyToClipboard
              text={
                form_1500_data?.claim_and_service_line_details?.rendering_provider?.middle_name ||
                ''
              }
            />
          </Box>
        )}
        {form_1500_data?.claim_and_service_line_details?.rendering_provider?.npi && (
          <Box sx={fieldContainerStyle}>
            <Typography sx={fieldLabelStyle}>NPI</Typography>
            <FHCopyToClipboard
              text={form_1500_data?.claim_and_service_line_details?.rendering_provider?.npi || ''}
            />
          </Box>
        )}
        <Box sx={fieldContainerStyle}>
          <Typography sx={fieldLabelStyle}>Taxonomy</Typography>
          <FHCopyToClipboard
            text={
              form_1500_data?.claim_and_service_line_details?.rendering_provider?.taxonomy || ''
            }
          />
        </Box>
      </Box>
      <Box sx={dividerStyle}></Box>
      <Box display={'flex'} flexDirection={'column'} mt={4}>
        <Typography variant="h4" sx={sectionTitleStyle} mb={3}>
          Pay to provider address
        </Typography>
        <Box sx={fieldContainerStyle}>
          <Typography sx={fieldLabelStyle}>Address</Typography>
          <Box display={'flex'} alignItems={'center'}>
            <Typography sx={fieldContentStyle}>Address line one: </Typography>
            <FHCopyToClipboard
              text={
                form_1500_data?.claim_and_service_line_details?.pay_to_provider_address
                  ?.address_line_one || ''
              }
              sx={{ ml: 0 }}
            />
          </Box>
          <Box display={'flex'} alignItems={'center'}>
            <Typography sx={fieldContentStyle}>Address line two: </Typography>
            <FHCopyToClipboard
              text={
                form_1500_data?.claim_and_service_line_details?.pay_to_provider_address
                  ?.address_line_two || ''
              }
              sx={{ ml: 0 }}
            />
          </Box>
          <Box display={'flex'} alignItems={'center'}>
            <Typography sx={fieldContentStyle}>City: </Typography>
            <FHCopyToClipboard
              text={
                form_1500_data?.claim_and_service_line_details?.pay_to_provider_address?.city || ''
              }
              sx={{ ml: 0 }}
            />
          </Box>
          <Box display={'flex'} alignItems={'center'}>
            <Typography sx={fieldContentStyle}>State: </Typography>
            <FHCopyToClipboard
              text={
                form_1500_data?.claim_and_service_line_details?.pay_to_provider_address?.state || ''
              }
              sx={{ ml: 0 }}
            />
          </Box>
          <Box display={'flex'} alignItems={'center'}>
            <Typography sx={fieldContentStyle}>ZIP code: </Typography>
            <FHCopyToClipboard
              text={
                form_1500_data?.claim_and_service_line_details?.pay_to_provider_address?.zip || ''
              }
              sx={{ ml: 0 }}
            />
          </Box>
        </Box>
      </Box>
      <Box sx={dividerStyle}></Box>
      <Box display={'flex'} flexDirection={'column'} mt={4}>
        <Typography variant="h4" sx={sectionTitleStyle} mb={3}>
          Payer information
        </Typography>
        <Box sx={fieldContainerStyle}>
          <Typography sx={fieldLabelStyle}>Payer primary ID</Typography>
          <FHCopyToClipboard
            text={
              form_1500_data?.claim_and_service_line_details?.payor_information?.primary_id || ''
            }
          />
        </Box>
      </Box>
      <Box sx={dividerStyle}></Box>
    </>
  );
}

export default ClaimServiceLineDetails;
